import { render } from "./IntegrationForm.vue?vue&type=template&id=e6d1203a&scoped=true"
import script from "./IntegrationForm.vue?vue&type=script&lang=js"
export * from "./IntegrationForm.vue?vue&type=script&lang=js"

import "./IntegrationForm.vue?vue&type=style&index=0&id=e6d1203a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6d1203a"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QSelect,QBtn});
